
<template>
  <div :class="isHome?'h-c':'h-c h-cc'">
    <div>热门城市</div>
    <div>
      <img width="7" src="../../../assets/images/zuo.png" />
    </div>
    <div
      v-for="(i,k) in cityData"
      :class="k==isIndex?'c':''"
      :id="i.cityCode==isSelectCode?'c':''"
      :key="k"
      @click="getDetails(i,k)"
    >{{i.cityName}}</div>
    <div>
      <img width="7" src="../../../assets/images/you.png" />
    </div>
  </div>
</template>
<script>
import axios from '@/api/road.js'
export default {
  data() {
    return {
      cityData: [],
      isIndex: -1
    }
  },
  props: {
    isHome: Boolean,
    isSelectCode: String
  },
  watch: {},
  created() {
    this.getTop20City()
  },
  methods: {
    getDetails(e, k) {
      this.isIndex = k
      if (this.isHome) {
        this.$router.push({
          path: '/roadOperation/hotCities',
          query: {
            id: 0,
            cityName: e.cityName,
            cityCode: e.cityCode,
            isHotCity: true
          }
        })
      } else {
        this.$emit('returnCityData', e)
      }
    },
    // 获取热门城市
    getTop20City() {
      axios.getTop20City().then(e => {
        if (e.data) {
          this.cityData = e.data
        }
      })
    }
  }
}
</script>
 
<style>
.h-c {
  position: absolute;
  width: 98%;
  left: 1%;
  top: 15px;
  background: rgba(25, 29, 50, 0.6);
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  z-index: 100;
  border: 1px solid #323856;
  color: #ffffff;
  padding: 0;
  overflow-x: auto;
  overflow-y: hidden;
  white-space: nowrap;
  font-size: 14px;
}
.h-cc {
  width: 92%;
  height: 60px;
  left: 7%;
}
/* .h-c::-webkit-scrollbar {
  display: none;
} */
.h-c > div {
  display: inline-block;
  padding: 10px 20px;
}
.h-c > div:hover {
  cursor: pointer;
  color: #00a0ff;
}
.h-c > div.c,
.h-c > div#c {
  color: #00a0ff;
}
.h-c > div:first-child {
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  width: 120px;
  line-height: 30px;
  margin-right: 5px;
  text-align: center;
}

.h-c > div:nth-child(2),
.h-c > div:last-child {
  background: #444a67;
  border-radius: 2px;
  padding: 15px 0;
  text-align: center;
  width: 24px;
  height: 48px;
}
.h-c > div:last-child {
  position: absolute;
  right: 5px;
  top: 5px;
}
</style>